import { Contact as ContactSection } from "../components/Contact";
import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const contactInfo = [
  {
    icon: MapPin,
    title: "Headquarters",
    details: ["Houston, Texas, USA"],
  },
  {
    icon: Phone,
    title: "Phone",
    details: ["(713) 936-9666"],
  },
  {
    icon: Mail,
    title: "Email",
    details: ["info@m2l-usa.com"],
  },
  {
    icon: Clock,
    title: "Hours",
    details: ["Mon - Fri: 9AM - 6PM CST"],
  },
];

const ContactPage = () => {
  return (
    <main className="pt-20">
      {/* Hero */}
      <section className="py-16 bg-surface-solid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <span className="text-primary text-sm font-medium tracking-[0.2em] uppercase mb-4 block">
              Get in Touch
            </span>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-6">
              Let's Start Your{" "}
              <span className="gradient-text">Journey Together</span>
            </h1>
            <p className="text-xl text-white/60">
              Have questions about our programs? Ready to take the next step? 
              We're here to help you achieve your educational goals.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-12 bg-[#060B19]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {contactInfo.map((item, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                className="glass-card rounded-xl p-6 text-center"
              >
                <div className="w-12 h-12 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-4">
                  <item.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-semibold text-white mb-2">{item.title}</h3>
                {item.details.map((detail, dIdx) => (
                  <p key={dIdx} className="text-white/60 text-sm">{detail}</p>
                ))}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactSection />

      {/* Map */}
      <section className="py-16 bg-surface-solid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-8"
          >
            <h2 className="font-heading text-2xl font-bold text-white mb-2">
              Our Location
            </h2>
            <p className="text-white/60">
              Visit us at our Houston headquarters
            </p>
          </motion.div>

          <div className="rounded-2xl overflow-hidden glass-card h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3463.0!2d-95.4!3d29.76!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjnCsDQ1JzM2LjAiTiA5NcKwMjQnMDAuMCJX!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg)' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="M2L Location"
            />
          </div>

          <div className="text-center mt-6">
            <a
              href="https://www.google.com/maps/dir//management+to+learn+houston"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-primary hover:underline"
            >
              <MapPin className="w-4 h-4" />
              Get Directions
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
